
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {InovaRequirePermissionDirective} from './permission-required.directive'
import {InovaRequireRoleDirective} from './role-required.directive'
import { ServiceRequiredDirective } from './service-required.directive';
import { ClickOutsideDirective } from './click-outside.directive';


@NgModule({
  declarations: [InovaRequirePermissionDirective,InovaRequireRoleDirective, ServiceRequiredDirective,ClickOutsideDirective],
  imports: [CommonModule],
  exports:[InovaRequirePermissionDirective,InovaRequireRoleDirective, ServiceRequiredDirective,ClickOutsideDirective]
})
export class InovaCoreDirectivesModule { }